import request from '@/utils/request'

// 查询云种植订单分页
export function pageCloudPlantOrder(data) {
  return request({
    url: '/cloudplant/order/page',
    method: 'post',
    data: data
  })
}

// 导出云种植订单
export function exportCloudPlantOrder(data) {
  return request({
    url: '/cloudplant/order/export',
    method: 'post',
    data: data
  })
}
